import Vue from 'vue'
import Vuex from 'vuex'

import content from '@/store/content'
import local from '@/store/local'
import siteplan from '@/store/siteplan'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    content,
    local,
    siteplan
  },
  state: {
    version: '1.0.13',
    default: null,
    markers: null,
    active: {
      infoWindows: [],
      plot: {},
      filters: {
        availability: [],
        bedrooms: [],
        plots: [],
        style: [],
        type: [],
        price: {
        }
      }
    },
    sideNavLengths: {
      floorPlan: null,
      specification: null,
      purchase: null
    },
    activeTab: 0,
    prevTab: 0,
    sidebarTab: 0,
    prevSidebarTab: 0,
    openFilter: null
  },

  mutations: {
    setMarkers (state, payload) {
      state.markers = payload
    },
    setDefault (state, payload) {
      state.default = payload
    },
    setActiveFilter (state, payload) {
      state.openFilter = payload
    },

    setActiveTab (state, payload) {
      state.prevTab = state.activeTab
      state.activeTab = payload
    },
    setSidebarNav (state, payload) {
      state.prevSidebarTab = state.sidebarTab
      state.sidebarTab = payload
    },

    setPurchaseLength (state, payload) {
      state.sideNavLengths.purchase = payload
    },
    setFloorPlanLength (state, payload) {
      state.sideNavLengths.floorPlan = payload
    },
    setSpecificationLength (state, payload) {
      state.sideNavLengths.specification = payload
    },
    // setTestimonialsNav (state, payload) {
    //   state.sideNavAbout.testimonial = payload
    // },
    // setAboutsNav (state, payload) {
    //   state.sideNavAbout.about = payload
    // },
    clearFilters (state) {
      let a = state.plotIndex.slice(0)
      let b = []

      for (let i = 0; i < a.length; i++) {
        b.push(a[i].plot_number)
      }

      state.active.filters = {
        availability: [],
        bedrooms: [],
        plots: b,
        style: [],
        type: [],
        price: {
          max: 1000000,
          min: 0
        }
      }
    },
    setActiveIndex (state, payload) {
      state.previousIndex = state.activeIndex
      state.activeIndex = payload
    },
    setFilters (state, payload) {
      // Update state filters
      switch (payload.target) {
        case 'availability':
          state.active.filters.availability = payload.value
          break
        case 'bedrooms':
          state.active.filters.bedrooms = payload.value
          break
        case 'style':
          state.active.filters.style = payload.value
          break
        case 'type':
          state.active.filters.type = payload.value
          break
        case 'price':
          state.active.filters.price = payload.value
          break
      }

      let a = state.plotIndex.slice(0)
      let b = []

      let filters = state.active.filters

      for (let i = 0; i < a.length; i++) {
        let pass = false
        if (filters.type.length === 0 || filters.type.includes(a[i].type.value)) {
          if (filters.availability.length === 0 || filters.availability.includes(a[i].plot_status)) {
            if (filters.bedrooms.length === 0 || filters.bedrooms.includes(a[i].bedrooms)) {
              if (filters.style.length === 0 || filters.style.includes(a[i].plot_style)) {
                if (a[i].plot_price !== '' && a[i].plot_price >= filters.price.min && a[i].plot_price <= filters.price.max) {
                  pass = true
                }
                if (a[i].plot_price === '') {
                  pass = true
                }
              }
            }
          }
        }

        if (pass) {
          b.push(a[i].plot_number)
        }
      }
      state.active.filters.plots = b
    },
    getLocalStorage (state) {
      const storageKey = 'laurus-homes-interactive'
      if (window.localStorage.getItem(storageKey)) {
        state.content = JSON.parse(window.localStorage.getItem(storageKey))
      }
    },
    setLocalStorage (state) {
      const storageKey = 'laurus-homes-interactive'
      window.localStorage.setItem(storageKey, JSON.stringify(state.content))
    }
  },
  actions: {
    init () {
      // this.commit('getLocalStorage')
      this.dispatch('getContent')
    },
    getLocalStorage (state) {
      const storageKey = 'laurus-homes-interactive'
      if (window.localStorage.getItem(storageKey)) {
        let localStorage = window.localStorage.getItem(storageKey)
        state.storage = JSON.parse(localStorage)
      } else {
        this.dispatch('getDevelopment')
      }
    }
  }
})
